import { __, addIndex, apply, ascend, compose as C, chain, clamp, divide, filter as f, 
    flatten, fromPairs, groupBy as g, identity, includes, indexBy,isNotEmpty,isNotNil,juxt,
    length as len, map as m, mapAccum, objOf, prop as p, path, props, repeat, keys as take_keys,
    values, always,toPairs,head, range as rng,last,sum,omit,sort,defaultTo,ifElse,isEmpty,
    countBy,tail,uniq,
    tap,
    sortWith,
    descend,
    unnest} from 'ramda';
import { scaleLinear, scaleOrdinal, scaleSqrt } from 'd3';
import { the_key } from './helpers';

export const initialState = {
    seat_keys: [],
    steps: {},
    current: {},
    participants: {},
    seat_data: {},
    texts: {},
    mode: "initial",
    zoom_state: true,
    current_key: null,
    counts:{},
    sorted:{}
};
/* 
const heartOutlinePoint = (t, {W,H,margin}) => {
    const {min,pow,sin,cos} = Math;
    const scale = min((W-2*margin)/34,(H-2*margin)/30);
    const x = 16*pow(sin(t),3)*1.1;
    const y = (13*cos(t)-5*cos(2*t)-2*cos(3*t)-cos(4*t))*1.1; 
    return {x: W/2+x*scale+91,y: H/2-y*scale+1105 };
}; */

/* function randomHeartPoint({W, H, margin}) {
  const scale = Math.min((W - 2*margin)/2, (H - 2*margin)/2) / 1.4;
  const cx = W/2, cy = H/2;
  while (true) {
    const x = (Math.random() * 2 - 1) * 2
    const y = (Math.random() * 2 - 1) * 2;
    if (Math.pow(x*x + y*y - 1, 3) - x*x*y*y*y <= 0) {
      return { x: cx + x * scale+91, y: cy - y * scale+1105 };
    }
  }
}
 */
    
export const createSeats = (xs,{W,H,margin}) => C(
    xs => ({
        seat_keys:m(p("key"),xs),
        seat_data:indexBy(p("key"),xs)
    }),
    chain(x =>
            addIndex(m)((x1, n1) => {
/*             const { x: heart_x, y: heart_y } = randomHeartPoint({W,H,margin}); */
            const seat_x = W-(x1.vertical ? x1.left : x1.left + n1 * 50) + 45,
                seat_y =  (x1.vertical ? x1.top + ((x1.area === 2 && x.row === 1 && (n1+x1.start) <= 7) ? 6-n1 : n1) * 50 : x1.top) + 1305,
                mar = margin,
                edge_x = seat_x > W/2 ? W+91-mar : mar+91,
                edge_y = seat_y > H/2+1305 ? H+1305-mar : mar+1305,
                seat_edge_x = clamp(mar+91,W+91-mar,seat_x),
                seat_edge_y = clamp(mar+1305,H+1305-mar,seat_y),
                seat_2_edge_x = n1%2 ? clamp(mar/2+91,W+91-mar/2,seat_x) : (seat_x > W/2+91 ? W+91-mar/2 : mar/2+91),
                seat_2_edge_y = n1%2 ? (seat_y > H/2+1305 ? H+1305-mar/2 : mar/2+1305) : clamp(mar/2+1305,H+1305-mar/2,seat_y)
            return ({
            ...x1,
            
            key: `${x1.area}-${x1.row}-${n1+x1.start}`,
            seat: n1 + x1.start,
            seat_color: ["","black","white"][x1.area],
            seat_x,seat_y,seat_edge_x,seat_edge_y,edge_x,edge_y,seat_2_edge_x,seat_2_edge_y,/* heart_x,heart_y */
        })}, repeat(x, x.n))
    ))(xs)

const set_x_y = (x_value, y_value, {current,current_key, params, has_x, has_y, x, new_margin}) => {
  const both_if_both = (has_x && has_y)
    ? (x_value !== undefined && y_value !== undefined)
    : (x_value !== undefined || y_value !== undefined);

  const useMargin = (new_margin !== undefined ? new_margin : params.margin);

  const computeX = () => {
/*     if (current_key === 60) return x.heart_x; */
    if (params.mode === "sorted") return x.sorted_x;
    if (!has_x && !has_y) return x.seat_x;
    if (both_if_both) {
      const v = current.x_pos?.x_fn(x_value, useMargin);
      const base = (v !== undefined ? v : params.W / 2);
      return base + 91;
    }
    if (has_x && !has_y) return x.seat_edge_x;
    if (!has_x && has_y) return x.edge_x;
    return x.seat_2_edge_x;
  };

  const computeY = () => {
/*     if (current_key === 60) return x.heart_y; */
    if (params.mode === "sorted") return x.sorted_y;
    if (!has_x && !has_y) return x.seat_y;
    if (both_if_both) {
      const v = current.y_pos?.y_fn(y_value, useMargin);
      const base = (v !== undefined ? v : params.H / 2);
      return base + 1305;
    }
    if (has_x && !has_y) return x.edge_y;
    if (!has_x && has_y) return x.seat_edge_y;
    return x.seat_2_edge_y;
  };

  const coords = { x: computeX(), y: computeY() }
  return {...coords, target_x: coords.x, target_y: coords.y};
};

const set_color = ({color,x_pos,y_pos,mode,current,has_x,has_y,zoom_state,x}) => {
    const is_black = (!zoom_state && ((has_x || has_y) || mode !== "grid"));
    return {color: 
        isNotNil(color) ? current.color?.color_fn(color) : (is_black ? "black" : x.seat_color),
        opacity: (mode === "grid" && (has_x && x_pos) || (has_y && y_pos))
            || isNotNil(color) || zoom_state ? 1 : 0.2
    }
}
const set_size_and_roundness = ({size,moving,current}) => {
    const screen_size = !size ? 2 : current.size?.size_fn(size)
    return {
        size: (Math.pow(screen_size,1.1))*(moving ? 12: 18),
        cr: (screen_size*screen_size*3) || 10,
    }
}

const legend_bubbles = () => {
    return m(() => ({
        "x": 1138,
        "y": 2242,
        "key": "",
        "fill": "black",
        "size": 60,
    }),)
}

const update_seat = ({participants,current,current_key,params,has_x,has_y,zoom_state,new_margin}) => x => {
    const responses = participants[x.key];

    const {color,size,x_pos,y_pos}= !current ? {} : C(
        m(C(
            ifElse(isEmpty,always(undefined),sum),
            f(isNotNil),
            m(p(__,responses)),
            p("id"))),
        defaultTo([])
    )(current);
    return ({...x,
        ...set_x_y(x_pos,y_pos,{current,current_key,has_x,has_y,params,x,new_margin}),
        ...set_color({color,x_pos,y_pos,has_y,has_x,zoom_state,mode:params.mode,x,current}),
        ...set_size_and_roundness({size,moving:(has_x || has_y),current})
    })
}


const calc_scales = ({participants,counts,step_scales,current_key,params:{W,H,margin}}) => C(
    flatten,values,
    addIndex(m)((block,block_n,blocks) => {

        const grouped = C(
            omit([NaN]),
            g(identity),
            m(x => sum(m(k => x[k],block.id))),
            values
        )(participants || {})

        const answered = m(p(__,counts),block.id);
        const nth = blocks.slice(0,block_n+1).filter(b => b.location === block.location).length;
        const percents = m(C(divide(__,flatten(values(grouped)).length),len),grouped)
        const response_count = m(len,grouped);
        const [data,scale_colors,labels,scales] = C(
            m(x => (block.type === "scale" && block.location === "left") ? [...x].slice().reverse() : x),
            props(["values","scale_colors","labels","scales"])
        )(block || {})
        const double = C(len,uniq,m(p("location")))(blocks);
        const mar = (3-double)*margin;
        const [lenX, lenY] = [H - (4/double) * margin, W - (4/double) * margin];
        const [wX,wY] = [(H-2*margin)/data.length,(W-2*margin)/data.length];
        const truncate = x => x.length > 50 ? x.slice(0,60)+" ..." : x;
        const params = C(
            last,
            addIndex(mapAccum)((acc, bar, bar_n) => {
                const length = (d) => !percents[bar] ? 30 :
                    (d - (2*margin) - ((data.length - 1) * 30) - (data.length-values(percents).length)*30) * percents[bar];
                const [h,w,x,y] = block.location === "left" ? 
                    [length(H),30, -100,acc+ bar_n * 30] :
                    [30,length(W),acc+ bar_n * 30,1105] ;
                const nextAcc = acc + (block.location === "left" ? h : w);
                return [nextAcc, {width: w,height: h, x, y, 
                    fill: scales.includes("color") ? scale_colors[bar_n] : "black", 
                    key: bar, 
                    label_text: truncate(labels[bar_n]) || "",
                    text_x:block.location === "left" ? 20 : bar_n*wY+margin+200,
                    text_y:block.location === "left" ? (bar_n+0.5)*wX+margin+1485 : mar+1385,
                    count: response_count[bar] || "",
                    label: `${(percents[bar] ? Math.round((percents[bar] || 0)*100) +"%" : "")}`, 
                    location: block.location }];
            }, block.location === "left" ? 1505 : margin/2+200), 
            sort(ascend),
        )(data)

        const lines = C(
            addIndex(m)((bar, bar_n) => {
                const [x1,x2,y1,y2] = block.location === "top" ? 
                    [
                        (bar_n+1)*wY+margin+100,
                        (bar_n+1)*wY+margin+100,
                        mar+1305,
                        mar+1305+lenX
                    ] : [
                        mar+45,
                        mar+45+lenY,
                        (bar_n+1)*wX+margin+1305,
                        (bar_n+1)*wX+margin+1305
                    ];
                return {
                    location: block.location,
                    x1,x2,y1,y2,
                    centerX: (x1 + x2) / 2,
                    centerY: (y1 + y2) / 2
                }
            }),
            tail
        )(data)

        return {...block,nth,percents,params,answered,lines,is_col:scales.length === 1 && scales[0] === "color"}
    }),
)(step_scales?.[current_key])

const sortedOrder = (participants,current) => xs => {
    const ordered = C(sortWith([
        ascend(p("seat_x")),
        ascend(p("seat_y"))
    ]),values)(xs);
    return C(
        indexBy(p("key")),
        addIndex(m)((x,n) => ({...x,sorted_x:ordered[n]?.seat_x,sorted_y:ordered[n]?.seat_y})),
        sortWith([
            ascend(x => participants[x.key]?.[current?.color?.id[0]] || 10)
        ]),
        values
    )(xs)
}

const set_seats = ({seat_data,seat_keys,counts,step_scales,questions,current_key,
    participants,current,fns,zoom_state},params,single) => {

    const {x_pos:has_x,y_pos:has_y} = current;
    const new_margin = 2*params.margin-20;
    const update_fn = update_seat({seat_data,participants,current,current_key,fns,
        params,has_x,has_y,questions,zoom_state,new_margin});
    return ({
        seat_data:C(
            xs => (params.mode !== "sorted" && single) ? {...xs,[single] : update_fn(xs[single])} :m(update_fn,xs),
            params.mode === "sorted" ? sortedOrder(participants,current) : identity
        )(seat_data),
        ...((seat_keys && step_scales && current_key) ? 
        {scales: calc_scales({seat_keys,step_scales,current_key,counts,participants,params})} : {})
})}


const color_scale = ({type,colors,domain}) =>
    type === "nominal" ? scaleOrdinal().domain(domain).range(colors) : 
    scaleLinear().domain(domain).range(colors)
const position_scale = (len, margin, {domain}) => (x, new_margin) => {
  const m = (new_margin !== undefined ? new_margin : margin);
  return scaleLinear()
    .domain(domain)
    .range([m, len - m])(x);
};
const size_scale = ({type,domain}) =>  type === "nominal" ? always(30) : 
    scaleSqrt().domain(domain).range([1,4])
const name_types = x => ["_","color","x_pos","y_pos","size"][x.type_id]


const setSteps = (payload,{W,H,margin}) => {
    const steps = C(
        m(C(
            m(x => C(
                xs => {
                    const min = xs.reduce((acc,c) => acc + (c.value < 0 ? -1 : 0),0) || 1,
                        max = xs.reduce((acc,c) => acc + (c.value > 0 ? 1 : 0),0),
                        range = max-min + 1,
                        domain = [min,max],
                        values = xs.length !== range ? rng(min,max+1)  : m(p("value"),xs),
                        type = head(xs).type,
                        question = head(xs).question,
                        labels = m(p("text"),xs),
                        id = m(p("question_id"),x);
                    const colors = xs
                        .filter(x => x.question_id === xs[0].question_id)
                        .map(x => x.color)
                    const picked_domain = {"scale":[min,0,max],"nominal":values}[type] || [min,max];
                    const color_fn = color_scale({type,
                        domain:picked_domain,colors});
                    return xs.length === 1 ? xs : {min,max,range,colors,values,labels,id,color_fn,type,question,
                        x_fn: position_scale(W, margin, { 
                            domain: type === "nominal" ? [1, values.length] : domain 
                        }),
                        y_fn: position_scale(H, margin, { 
                            domain: type === "scale" ? [...domain].reverse() 
                                    : type === "nominal" ? [1, values.length] 
                                    : domain 
                        }),
                        size_fn:size_scale({type,domain:type==="scale" ? [...domain].reverse() :domain}),
                        sizes: values.map(size_scale({type,domain})),
                        scale_colors:values.map(color_fn),
                    }
                },
                chain(x => {
                    const q = x.questions;
                    const domain = [q.min,q.max];
                    const colors = [q.min_color,q.max_color];
                    return q.type !== "number" ? 
                        q.question_choices
                            .filter(c => c.type === q.type)
                            .sort((a,b) => a.value - b.value)
                            .map(x => ({...x,question:q.text})) : 
                        [{type:"number",id:[q.id],min:q.min,max:q.max,colors,question:q.text,
                            x_fn:position_scale(W,margin,{domain}),
                            y_fn:position_scale(H,margin,{domain}),
                            size_fn:size_scale({type:"number",domain}),
                            color_fn:color_scale({type:"number",domain,colors}),
                            sizes: domain.map(size_scale({type:"number",domain})),
                            range:q.max+1-q.min,
                            labels:domain,
                            values:domain,
                        }];
                })
            )(x)),
            g(name_types),
        )),
        m(p("steps_questions")),
        indexBy(p("id"))
    )(payload)

    const step_scales = m(C(
        values,
        m(xs => ({
            scales: m(([x]) => x,xs),
            location: includes("y_pos",m(head,xs)) ? "left" : "top",
            ...xs[0][1]})),
        g(C(path([1,"id"]))),
        toPairs    
    ),steps)

    const current_key = path([0,"events","current"], payload) || 1;
    const current = steps[current_key];
    const zoom_out = m(p("id"),f(p("zoom_out"),payload));

    const texts = C(
        m(p("text")),
        indexBy(p("id")),
        f(p("text"))
    )(payload);
    
    return {steps,step_scales,current,current_key,zoom_out,texts,
        sorted: C(m(p("sorted")),indexBy(p("id")))(payload),
        zoom_state:zoom_out.includes(current_key), 
        current_text:texts[current_key]};
}

const add_response = ({new:{participant_id,question_id,value}},{participants,keys}) => {
    const k = keys[participant_id]
    const with_new_added = {
        ...(participants||{}),[k] :{
            ...(participants[k]||{}),
            [question_id]:Number(value)
        }        
    }
    const counts = C(countBy(identity),chain(take_keys),values)(with_new_added)
    return {participants : with_new_added,counts}
}

const pick_data = {
    data: {
        load: C(
            m(C(
                fromPairs,
                m(juxt([
                    p("question_id"),
                    C(Number,p("value"))])),
                p("responses"))),
            indexBy(the_key)),
        insert: C(
            indexBy(the_key),
            p("data")),
        update: C(
            indexBy(the_key),
            p("new"))},
    keys: {
        load: C(
            m(the_key),
            indexBy(p("id"))
        ),
        insert: C(
            apply(objOf),
            juxt([p("id"),the_key]),
            p("new")
        ),
        update: C(
            apply(objOf),
            juxt([p("id"),"id",the_key]),
            p("new")
        )
    }
}

const setCurrent = ({steps,zoom_out,texts},current) =>{
    return ({
        current_text:texts[current],
        current: steps[current],
        current_key:current,
        zoom_state: zoom_out.includes(current)
    })
}

const update_text = (payload,state) => ({...state,texts: {...state.texts,[payload.new.id]: payload.new.text},
    ...(payload.new.id === state.current_key ? {current_text:payload.new.text} : {})})

export const reducer = (state, {type,payload}) => {
    const params = {W:2048,H:1874,margin:200}
    const participants = (fn) => ({
        participants: {...state?.participants, ...pick_data.data[fn](payload)},
        keys: {...state?.keys, ...pick_data.keys[fn](payload)},
        counts: fn === "load" ? C(countBy(identity),chain(take_keys),values)(pick_data.data[fn](payload)) : state?.counts
    })

    const altered_state = { ...state, ...(
        "LOAD_SEATS" === type          ? createSeats(payload,params)           :
        "LOAD_STEPS" === type          ? setSteps(payload,params)              :
        "LOAD_QUESTIONS" === type      ? {questions:indexBy(p("id"),payload)}  :
        "SET_CURRENT" === type         ? setCurrent(state,payload.new.current) :
        
        "LOAD_PARTICIPANTS" === type   ? participants("load")                  :
        "INSERT_PARTICIPANTS" === type ? participants("insert")                :
        "UPDATE_PARTICIPANTS" === type ? participants("update")                :

        "UPDATE_RESPONSES" === type    ? add_response(payload,state)           :
        "UPDATE_STEPS" === type        ? update_text(payload,state)            :
        {}),
    }
    const answered = Math.max(altered_state?.scales?.[0]?.answered)
    const election_results = {
        1:{target_x:450, target_y:2242, val:1, color:"#ffe200",percent:0.101,opacity:0.2,id:"vote1",cr:12,size:26},
        2:{target_x:620, target_y:2242, val:2, color: "#e10600",percent: 0.215,opacity:0.2,id:"vote2",cr:12,size:26},
        3:{target_x:793, target_y:2242, val:3, color: "#7fd1fa",percent:0.139,opacity:0.2,id:"vote3",cr:12,size:26},
        5:{target_x:1115, target_y:2242, val:5, color: "#ff9c60",percent:0.076,opacity:0.2,id: "vote5" ,cr:12,size:26},
        6:{target_x:1276, target_y:2242, val:6, color: "#13aa68",percent: 0.468,opacity:0.2,id: "vote6" ,cr:12,size:26},
    }

    const real_votes = [540,520,521].includes(altered_state?.current_key) ? C(
        m(x => Math.round(x.percent*answered)),
    )(election_results)
    : []

    const all_or_some = ["INSERT_PARTICIPANTS", "UPDATE_PARTICIPANTS","UPDATE_RESPONSES"].includes(type) ? 
        state.keys[payload.new.participant_id] : null;
    const {x_pos,y_pos} = altered_state?.current || {};

    const mode = altered_state?.sorted[altered_state?.current_key] ? "sorted" : (x_pos || y_pos) ? "grid" : "initial";
    return {...altered_state,real_votes,mode,...params,...set_seats({...altered_state,mode}, {...params,mode},all_or_some)}
}